export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const formatPhoneNumber = (value) => {
  // Remove all non-digits
  const digits = value.replace(/\D/g, '');
  
  // Handle different starting formats
  let normalized = digits;
  if (digits.startsWith('27')) {
    normalized = digits.slice(2);
  } else if (digits.startsWith('0')) {
    normalized = digits.slice(1);
  }
  
  // Limit to 9 digits after country code
  normalized = normalized.slice(0, 9);
  
  // Format as +27 XX XXX XXXX
  if (normalized.length > 0) {
    let formatted = '+27 ';
    if (normalized.length > 0) formatted += normalized.slice(0, 2);
    if (normalized.length > 2) formatted += ' ' + normalized.slice(2, 5);
    if (normalized.length > 5) formatted += ' ' + normalized.slice(5, 9);
    return formatted;
  }
  return value;
};

export const validatePhoneNumber = (phone) => {
  const digits = phone.replace(/\D/g, '');
  // Should have 11 digits total (+27 + 9 digits) or 9 digits (without country code)
  return digits.length === 11 || digits.length === 9;
};

export const getPhoneDigits = (phone) => {
  // Get normalized phone number for API
  const digits = phone.replace(/\D/g, '');
  if (digits.startsWith('27')) {
    return '+27' + digits.slice(2);
  } else if (digits.startsWith('0')) {
    return '+27' + digits.slice(1);
  } else if (digits.length === 9) {
    return '+27' + digits;
  }
  return '+' + digits;
};
